import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useCompanyRecipient = (id: string): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['recipient', id],
		queryFn: async() => {
			const { data: { recipient } } = await axios.get(`/recipients/${id}`);
      return recipient;
		}
	});
};